<a
  [routerLink]="documentCanBeOpened ? ['/document', this.documentId] : null"
  [queryParams]="queryParams"
>
  <div class="name">{{ name }}</div>
</a>
